import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '恋爱漫画', href: '/category/romance' },
    { label: '奇幻漫画', href: '/category/fantasy' },
    { label: '动作漫画', href: '/category/action' },
    { label: '悬疑漫画', href: '/category/mystery' },
    { label: '都市漫画', href: '/category/urban' },
    { label: '历史漫画', href: '/category/historical' },
    { label: '搞笑漫画', href: '/category/comedy' },
    { label: '恐怖漫画', href: '/category/horror' },
  ],
  about: [
    { label: '关于我们', href: '/about' },
    { label: '品牌介绍', href: '/about#brand' },
    { label: '口碑评价', href: '/about#reputation' },
    { label: '联系我们', href: '/about#contact' },
  ],
  legal: [
    { label: '用户协议', href: '/about' },
    { label: '隐私政策', href: '/about' },
    { label: '版权声明', href: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block">
              <span className="font-heading text-2xl font-black text-background-50 tracking-tight">
                韩漫网站
              </span>
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              韩漫网站——最全的韩国漫画免费在线阅读平台。通过韩漫网址快速导航，浏览韩漫大全合集，满足您对高质量漫画的阅读欲望。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">法律条款</h4>
            <ul className="space-y-2.5">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫网站. All rights reserved. 本站内容仅供学习交流使用。
          </p>
          <p className="text-xs text-background-600">
            韩漫网址 · 韩国漫画免费 · 韩漫大全
          </p>
        </div>
      </div>
    </footer>
  );
}